import { render, staticRenderFns } from "./counsel-report.vue?vue&type=template&id=6275b593&"
import script from "./counsel-report.vue?vue&type=script&lang=js&"
export * from "./counsel-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports